import React from 'react';
import { motion } from 'framer-motion';

import { Button } from '../ui/button';
import type { KnowledgeSourceGroup } from './types';

const MotionButton = motion(Button);

interface KnowledgeGroupSelectorProps {
  groups: KnowledgeSourceGroup[];
  onGroupSelect: (group: KnowledgeSourceGroup) => void;
}

export function KnowledgeGroupSelector({ groups, onGroupSelect }: KnowledgeGroupSelectorProps) {
  if (!groups.length) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full px-4 py-3">
      <p className="text-sm text-muted-foreground mb-2 text-right">Please select an option</p>
      <div className="flex flex-wrap justify-end gap-2">
        {groups.map((group, index) => (
          <MotionButton
            key={group.id}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.05 }}
            onClick={() => onGroupSelect(group)}
            variant="outline"
            className="border-border font-normal h-auto rounded-full px-4 py-1.5 text-sm"
          >
            {group.name}
          </MotionButton>
        ))}
      </div>
    </motion.div>
  );
}
